import { TranslateScope } from '@pegasus/translation/components';

export default TranslateScope;
